var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.440cfd01872a25cc20e9d3f8c44dc6d4.svg#bj';
                    var viewUrl = 'sprites.440cfd01872a25cc20e9d3f8c44dc6d4.svg#view-bj';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 80 29',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };